import {FLIP_CARD_SIDE} from '../../incase-domain/elements/flipCard';
import {FLIP_CARD, IFlipCardAction} from './types/flipCard.types';

export const flipCardAction = (elementId: string, flipCardSide: FLIP_CARD_SIDE): IFlipCardAction => ({
    type: FLIP_CARD,
    payload: {
        elementId,
        flipCardSide,
    },
});
